export default "__VITE_ASSET__DoVa5d4n__"